function randomize(url) {
  const partToAppend = new Date().getTime();

  if (url) {
    if (url.includes('?')) {
      url += `&rand=${partToAppend}`;
    } else {
      url += `?rand=${partToAppend}`;
    }
  }

  return url;
}

function parseQueryParam(paramName) {
  if (typeof URL === "function") {
    return new URL(document.location).searchParams.get(paramName);
  } else {
    const match = window.location.search.match(new RegExp(`${paramName}=([^&]+)`));
    if (match) {
      return match[1];
    } else {
      return '';
    }
  }
}

function removeQueryParam(paramName) {
  if (typeof URLSearchParams !== 'undefined') {
    const params = new URLSearchParams(document.location.search);
    params.delete(paramName);
    const paramString = params.toString();
    return window.location.protocol
      + '//'
      + window.location.host
      + (paramString ? ('?' + paramString) : '')
      + window.location.hash;
  } else {
    return setUrlParameter(document.location.href, paramName, '');
  }
}

function setUrlParameter(url, key, value) {
  var key = encodeURIComponent(key),
      value = encodeURIComponent(value);

  var baseUrl = url.split('?')[0],
      newParam = key + '=' + value,
      params = '?' + newParam;

  if (url.split('?')[1] === undefined){ // if there are no query strings, make urlQueryString empty
      urlQueryString = '';
  } else {
      urlQueryString = '?' + url.split('?')[1];
  }

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
      var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
      var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

      if (value === undefined || value === null || value === '') { // Remove param if value is empty
          params = urlQueryString.replace(removeRegex, "$1");
          params = params.replace(/[&;]$/, "");

      } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
          params = urlQueryString.replace(updateRegex, "$1" + newParam);

      } else if (urlQueryString == '') { // If there are no query strings
          params = '?' + newParam;
      } else { // Otherwise, add it to end of query string
          params = urlQueryString + '&' + newParam;
      }
  }

  // no parameter was set so we don't need the question mark
  params = params === '?' ? '' : params;

  return baseUrl + params;
}

export default {
  randomize,
  parseQueryParam,
  removeQueryParam,
};



// WEBPACK FOOTER //
// ./src/utils/url.js